import { memo } from 'react';

import { useIntl } from 'react-intl';

import { AutoDismissFlag } from '@atlaskit/flag';
import StatusErrorIcon from '@atlaskit/icon/core/status-error';
import { token } from '@atlaskit/tokens';

import { ComponentFlagProps } from 'src/redux/flags/types';

import { messages } from './revert-pull-request-error-flag.i18n';

export const RevertPullRequestErrorFlag = memo(
  ({ id, ...otherProps }: ComponentFlagProps) => {
    const intl = useIntl();
    return (
      <AutoDismissFlag
        {...otherProps}
        id={id}
        icon={
          <StatusErrorIcon
            spacing="spacious"
            label="error"
            color={token('color.icon.danger')}
          />
        }
        title={intl.formatMessage(messages.title)}
        description={intl.formatMessage(messages.description)}
        actions={[
          {
            content: intl.formatMessage(messages.learnMore),
            href: 'https://www.atlassian.com/git/tutorials/undoing-changes/git-revert',
            target: '_blank',
          },
        ]}
      />
    );
  }
);
